import { render, staticRenderFns } from "./StarryBackground.vue?vue&type=template&id=12a1882b"
import script from "./StarryBackground.vue?vue&type=script&lang=js"
export * from "./StarryBackground.vue?vue&type=script&lang=js"
import style0 from "./StarryBackground.vue?vue&type=style&index=0&id=12a1882b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports